/* eslint-disable jira/filename-case */
import getPillarProxyServerPort from '@jira/ssr__global-build-context/src/getPillarProxyServerPort.tsx';
import getRdeDns from '@jira/ssr__global-build-context/src/getRdeDns.tsx';
import getPillarEnableHttps from '@jira/ssr__global-build-context/src/getPillarEnableHttps.tsx';
import getLocalUrlOverride from '@jira/ssr__global-build-context/src/getLocalUrlOverride.tsx';
/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */
function getDevHostname(): string {
	const envDns = __SERVER__ ? getRdeDns() : process.env.RDE_DNS;
	return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
}

function getProxyServerPort(): number {
	const serverPort = __SERVER__
		? getPillarProxyServerPort()
		: process.env.__PILLAR_PROXY_SERVER_PORT;

	return serverPort ? parseInt(serverPort, 10) : 9000;
}

export function getLocalUrl(): string {
	if (__SERVER__) {
		const overridden = getLocalUrlOverride();
		return (
			overridden ??
			`${getPillarEnableHttps() ? 'https' : 'http'}://${getDevHostname()}:${getProxyServerPort()}`
		);
	}
	return `${process.env.__PILLAR_ENABLE_HTTPS === 'true' ? 'https' : 'http'}://${getDevHostname()}:${getProxyServerPort()}`;
}
